// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"ddaf9d50","93":"662d9fe1","373":"9c05fde1","453":"9562ac4f","599":"52bd7bf6","662":"13e10a47","758":"cad711df","762":"e5ee8636","924":"9cd315e7","994":"650e67af"}[chunkId] + ".chunk.js";
};